//@flow strict

import * as React from 'react';
import {
  BodySmall,
  SubTitleSmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TruncatedTextWithTooltip} from '@spaced-out/ui-design-system/lib/components/TruncatedTextWithTooltip';
import css from './module-addon-common.css';


export const LabelValue = ({
  label,
  value,
}: {
  label: string,
  value: string | React.Node,
}): React.Node => (
  <div className={css.keyValue}>
    <BodySmall color="secondary">{label}:</BodySmall>
    {typeof value === 'string' ? (
      <SubTitleSmall>
        <TruncatedTextWithTooltip tooltip={{bodyMaxLines: 3}}>
          {value}
        </TruncatedTextWithTooltip>
      </SubTitleSmall>
    ) : (
      value
    )}
  </div>
);
